<template>
  <div>
    <!-- VISTA CREAR INDIVIDUAL -->
    <div class="grid grid-cols-6 gap-6" >

      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="id_entidad_emisora" class="block text-sm font-medium text-gray-700">Entidad que emite medida de embargo <span style="color: red">(*)</span></label>
        <select id="id_entidad_emisora" :value="entidadEmisoraSeleccionada"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                @change="(entidadEmisoraNew)=>$emit('updateValues', {'id_entidad_emisora': customUpdateValueData('id_entidad_emisora', entidadEmisoraNew.target.value)})">
              <option value="" selected>Seleccione una entidad...</option>
              <option v-for="(entidad, index) of collectionEntidadesEmisoras" :key="'E'+index" :value="entidad.id">{{
                  entidad.nombre
                }}
              </option>
        </select>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="nit_entidad_emisora" class="block text-sm font-medium text-gray-700">NIT Entidad Emisora</label>
        <input type="text" id="nit_entidad_emisora" :value="nitEntidadEmisora" disabled
               style="background-color: #f3f3f3;"
               class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>

      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="numero_oficio" class="block text-sm font-medium text-gray-700">Número de Oficio <span style="color: red">(*)</span></label>
        <input type="text" id="numero_oficio" :value="loadData.numero_oficio"
               @change="(numeroOficioNew)=>$emit('updateValues', {'numero_oficio': customUpdateValueData('numero_oficio', numeroOficioNew.target.value)})"
               class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>

      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="fecha_oficio" class="block text-sm font-medium text-gray-700">Fecha de Oficio <span style="color: red">(*)</span></label>
        <input type="date" id="fecha_oficio" :value="loadData.fecha_oficio"
               @change="(fechaOficioNew)=>$emit('updateValues', {'fecha_oficio': customUpdateValueData('fecha_oficio', fechaOficioNew.target.value)})"
               class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="id_tipo_persona" class="block text-sm font-medium text-gray-700">Tipo de Persona Demandado <span style="color: red">(*)</span></label>
        <select id="id_tipo_persona" :value="loadData.id_tipo_persona ? loadData.id_tipo_persona : loadData.demandado.id_tipo_persona"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                @change="(idTipoPersonaNew)=>$emit('updateValues', {'id_tipo_persona': customUpdateValueData('id_tipo_persona', idTipoPersonaNew.target.value)})">
              <option value="" selected>Seleccione un tipo...</option>
              <option v-for="(tipo, index) of collectionTipoPersona" :key="'B'+index" :value="tipo.id" >{{
                  tipo.nombre
                }}
              </option>
        </select>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="tipo_identificacion_demandado" class="block text-sm font-medium text-gray-700">Tipo de Documento Demandado <span style="color: red">(*)</span></label>
        <select id="tipo_identificacion_demandado" :value="loadData.tipo_identificacion_demandado ? loadData.tipo_identificacion_demandado :loadData.demandado.id_tipo_identificacion"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                @input="{demandadoFieldsByDocument($event.target.value); 
                        updatePersona({tipo : 'demandado' , documento : loadData.identificacion_demandado ? loadData.identificacion_demandado : nombres_demandado.identificacion, tipoDocumento: $event.target.value })}"
                @change="(tipo_identificacion_demandadoNew)=>$emit('updateValues', {'tipo_identificacion_demandado': customUpdateValueData('tipo_identificacion_demandado', tipo_identificacion_demandadoNew.target.value)})">
                <option value="" selected>Seleccione un tipo...</option>
              <option v-for="(tipoDoc, index) of collectionTipoDoc" :key="'B'+index" :value="tipoDoc.id" >{{
                  tipoDoc.nombre_tipo_identificacion
                }}
              </option>
        </select>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="identificacion_demandado" class="block text-sm font-medium text-gray-700">Identificación Demandado <span style="color: red">(*)</span></label>
        <input type="text" id="identificacion_demandado" :value="loadData.identificacion_demandado ? loadData.identificacion_demandado : nombres_demandado.identificacion"
              @input="updatePersona({tipo : 'demandado' , documento : $event.target.value, tipoDocumento: loadData.tipo_identificacion_demandado ? loadData.tipo_identificacion_demandado : loadData.demandado.id_tipo_identificacion })"       
              @change="(identificacionDemandadoNew)=>$emit('updateValues', {'identificacion_demandado': customUpdateValueData('identificacion_demandado', identificacionDemandadoNew.target.value)})"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div v-if="loadData.tipo_identificacion_demandado == 6 || loadData?.demandado?.id_tipo_identificacion == 6" class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="primer_nombre_demandado" class="block text-sm font-medium text-gray-700"> Nombre Demandado <span style="color: red">(*)</span></label>
        <input type="text" id="primer_nombre_demandado" 
              :value="loadData.primer_nombre_demandado ? loadData.primer_nombre_demandado : nombres_demandado.primer_nombre" :style="{backgroundColor: !valida_disabled_demandado  ? '#e7e7e7' : ''}"
              :disabled="!valida_disabled_demandado"
              @change="(primerNombreDemandadoNew)=>$emit('updateValues', {'primer_nombre_demandado': customUpdateValueData('primer_nombre_demandado', primerNombreDemandadoNew.target.value)})"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div v-else class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="primer_nombre_demandado" class="block text-sm font-medium text-gray-700">Primer Nombre Demandado <span style="color: red">(*)</span></label>
        <input type="text" id="primer_nombre_demandado" 
              :value="loadData.primer_nombre_demandado ? loadData.primer_nombre_demandado : nombres_demandado.primer_nombre" :style="{backgroundColor: !valida_disabled_demandado ? '#e7e7e7' : ''}"
              :disabled="!valida_disabled_demandado"
              @change="(primerNombreDemandadoNew)=>$emit('updateValues', {'primer_nombre_demandado': customUpdateValueData('primer_nombre_demandado', primerNombreDemandadoNew.target.value)})"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div v-if="loadData.tipo_identificacion_demandado != 6 && tipo_documento_demandado" class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="segundo_nombre_demandado" class="block text-sm font-medium text-gray-700">Segundo Nombre Demandado </label>
        <input type="text" id="segundo_nombre_demandado" 
              :value="loadData.segundo_nombre_demandado ? loadData.segundo_nombre_demandado : nombres_demandado.segundo_nombre" :style="{backgroundColor: !valida_disabled_demandado ? '#e7e7e7' : ''}"
              :disabled="!valida_disabled_demandado"
              @change="(segundoNombreDemandadoNew)=>$emit('updateValues', {'segundo_nombre_demandado': customUpdateValueData('segundo_nombre_demandado', segundoNombreDemandadoNew.target.value)})"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div v-if="loadData.tipo_identificacion_demandado != 6 && tipo_documento_demandado" class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="primer_apellido_demandado" class="block text-sm font-medium text-gray-700">Primer Apellido Demandado </label>
        <input type="text" id="primer_apellido_demandado" 
              :value="loadData.primer_apellido_demandado ? loadData.primer_apellido_demandado : nombres_demandado.primer_apellido" :style="{backgroundColor: !valida_disabled_demandado ? '#e7e7e7' : ''}"
              :disabled="!valida_disabled_demandado"
              @change="(primerApellidoDemandadoNew)=>$emit('updateValues', {'primer_apellido_demandado': customUpdateValueData('primer_apellido_demandado', primerApellidoDemandadoNew.target.value)})"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div v-if="loadData.tipo_identificacion_demandado != 6 && tipo_documento_demandado" class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="segundo_apellido_demandado" class="block text-sm font-medium text-gray-700">Segundo Apellido Demandado </label>
        <input type="text" id="segundo_apellido_demandado"
              :value="loadData.segundo_apellido_demandado ? loadData.segundo_apellido_demandado : nombres_demandado.segundo_apellido" :style="{backgroundColor: !valida_disabled_demandado ? '#e7e7e7' : ''}"
              :disabled="!valida_disabled_demandado"
              @change="(segundoApellidoDemandadoNew)=>$emit('updateValues', {'segundo_apellido_demandado': customUpdateValueData('segundo_apellido_demandado', segundoApellidoDemandadoNew.target.value)})"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="tipo_identificacion_demandante" class="block text-sm font-medium text-gray-700">Tipo de identificacion Demandante <span style="color: red">(*)</span></label>
        <select id="tipo_identificacion_demandante" :value="loadData.tipo_identificacion_demandante ? loadData.tipo_identificacion_demandante : loadData.demandante.id_tipo_identificacion"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                @input="{demandanteFieldsByDocument($event.target.value);
                        updatePersona({tipo : 'demandante' , documento : loadData.identificacion_demandante ? loadData.identificacion_demandante : loadData.demandante.identificacion, tipoDocumento: $event.target.value })}"
                @change="(tipo_identificacion_demandanteNew)=>$emit('updateValues', {'tipo_identificacion_demandante': customUpdateValueData('tipo_identificacion_demandante', tipo_identificacion_demandanteNew.target.value)})">
              <option value="" selected>Seleccione un tipo...</option>
              <option v-for="(tipoDoc, index) of collectionTipoDoc" :key="'B'+index" :value="tipoDoc.id" >{{
                  tipoDoc.nombre_tipo_identificacion
                }}
              </option>
        </select>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="identificacion_demandante" class="block text-sm font-medium text-gray-700">Identificación Demandante <span style="color: red">(*)</span></label>
        <input type="text" id="identificacion_demandante" :value="loadData.identificacion_demandante ? loadData.identificacion_demandante : loadData.demandante.identificacion"
              @input="updatePersona({tipo : 'demandante', documento: $event.target.value, tipoDocumento: loadData.tipo_identificacion_demandante ? loadData.tipo_identificacion_demandante : loadData.demandante.id_tipo_identificacion})" 
              @change="(identificacionDemandanteNew)=>$emit('updateValues', {'identificacion_demandante': customUpdateValueData('identificacion_demandante', identificacionDemandanteNew.target.value)})"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div v-if="loadData.tipo_identificacion_demandante == 6 || loadData?.demandante?.id_tipo_identificacion == 6" class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="primer_nombre_demandante" class="block text-sm font-medium text-gray-700"> Nombre Demandante <span style="color: red">(*)</span></label>
        <input type="text" id="primer_nombre_demandante"
              :value="loadData.primer_nombre_demandante ? loadData.primer_nombre_demandante : nombres_demandante.primer_nombre" :style="{backgroundColor: !valida_disabled_demandante ? '#e7e7e7' : ''}"
              :disabled="!valida_disabled_demandante"
              @change="(nombreDemandanteNew)=>$emit('updateValues', {'primer_nombre_demandante': customUpdateValueData('primer_nombre_demandante', nombreDemandanteNew.target.value)})"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div v-else class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="primer_nombre_demandante" class="block text-sm font-medium text-gray-700"> Primer Nombre Demandante <span style="color: red">(*)</span></label>
        <input type="text" id="primer_nombre_demandante"
              :value="loadData.primer_nombre_demandante ? loadData.primer_nombre_demandante :  nombres_demandante.primer_nombre" :style="{backgroundColor: !valida_disabled_demandante ? '#e7e7e7' : ''}"
              :disabled="!valida_disabled_demandante"
              @change="(nombreDemandanteNew)=>$emit('updateValues', {'primer_nombre_demandante': customUpdateValueData('primer_nombre_demandante', nombreDemandanteNew.target.value)})"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div v-if="loadData.tipo_identificacion_demandante != 6 && tipo_documento_demandante" class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="segundo_nombre_demandante" class="block text-sm font-medium text-gray-700">Segundo Nombre Demandante </label>
        <input type="text" id="segundo_nombre_demandante" 
              :value="loadData.segundo_nombre_demandante ? loadData.segundo_nombre_demandante : nombres_demandante.segundo_nombre" :style="{backgroundColor: !valida_disabled_demandante ? '#e7e7e7' : ''}"
              :disabled="!valida_disabled_demandante"
              @change="(nombreDemandanteNew)=>$emit('updateValues', {'segundo_nombre_demandante': customUpdateValueData('segundo_nombre_demandante', nombreDemandanteNew.target.value)})"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div v-if="loadData.tipo_identificacion_demandante != 6 && tipo_documento_demandante" class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="primer_apellido_demandante" class="block text-sm font-medium text-gray-700">Primer Apellido Demandante </label>
        <input type="text" id="primer_apellido_demandante" 
              :value="loadData.primer_apellido_demandante ? loadData.primer_apellido_demandante : nombres_demandante.primer_apellido" :style="{backgroundColor: !valida_disabled_demandante ? '#e7e7e7' : '' }"
              :disabled="!valida_disabled_demandante"
              @change="(nombreDemandanteNew)=>$emit('updateValues', {'primer_apellido_demandante': customUpdateValueData('primer_apellido_demandante', nombreDemandanteNew.target.value)})"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div v-if="loadData.tipo_identificacion_demandante != 6 && tipo_documento_demandante" class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="segundo_apellido_demandante" class="block text-sm font-medium text-gray-700">Segundo Apellido Demandante </label>
        <input type="text" id="segundo_apellido_demandante" 
              :value="loadData.segundo_apellido_demandante ? loadData.segundo_apellido_demandante : nombres_demandante.segundo_apellido" :style="{backgroundColor: !valida_disabled_demandante ? '#e7e7e7' : ''}"
              :disabled="!valida_disabled_demandante"
              @change="(nombreDemandanteNew)=>$emit('updateValues', {'segundo_apellido_demandante': customUpdateValueData('segundo_apellido_demandante', nombreDemandanteNew.target.value)})"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="numero_proceso" class="block text-sm font-medium text-gray-700">Número de Proceso <span style="color: red">(*)</span></label>
        <input type="number" id="numero_proceso" :value="loadData.numero_proceso"
               @change="(numeroProcesoNew)=>$emit('updateValues', {'numero_proceso': customUpdateValueData('numero_proceso', numeroProcesoNew.target.value)})"
               class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="tipo_proceso" class="block text-sm font-medium text-gray-700">Clase de Proceso <span style="color: red">(*)</span></label>
        <input type="text" id="tipo_proceso" :value="loadData.tipo_proceso ? loadData.tipo_proceso: loadData.tipoProceso.nombre"
               @change="(tipoProcesoNew)=>$emit('updateValues', {'tipo_proceso': customUpdateValueData('tipo_proceso', tipoProcesoNew.target.value)})"
               class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="valor" class="block text-sm font-medium text-gray-700">Valor <span style="color: red">(*)</span></label>
        <input type="text" id="valor" :value="formattedValue || loadData.valor || loadData.valor_inicial"
        :disabled="loadData.valor_inicial !== null && loadData.valor_inicial !== undefined && loadData.valor_inicial !== ''"
        :style="{backgroundColor: loadData.valor_inicial ? '#F3F3F3' :''}"
        @input="updateValue($event.target.value)"
        @change="(valorNew)=>$emit('updateValues', {'valor': customUpdateValueData('valor', valorNew.target.value)})"
               class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="fecha_recibido_oficio" class="block text-sm font-medium text-gray-700">Fecha recibo del oficio medida <span style="color: red">(*)</span></label>
        <input type="date" id="fecha_recibido_oficio" :value="loadData.fecha_recibido_oficio"
               @change="(fechaRecibidoOficiooNew)=>$emit('updateValues', {'fecha_recibido_oficio': customUpdateValueData('fecha_recibido_oficio', fechaRecibidoOficiooNew.target.value)})"
               class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="observaciones" class="block text-sm font-medium text-gray-700">Observaciones</label>
        <textarea type="text" id="observaciones" :value="loadData.observaciones"
          @change="(observacionesNew) => $emit('updateValues', { 'observaciones': customUpdateValueData('observaciones', observacionesNew.target.value) })"
          class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" >
        </textarea>
      </div>
    </div>
     
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { separateNumberByCommaInput, useAPIRest } from '@/common/constants';
export default {  
  name: 'EmbargosPersonaCrearActualizarComponent',
  props: ['view', 'loadData', 'selectedData', 'customUpdateValueData', 'collectionTipoPersona','collectionTipoDoc','collectionEntidadesEmisoras'],
  emits: ["updateValues"],

  setup(props, {emit}){
    const valor = ref('');
    const valida_disabled_demandado = ref(props.view == 'actualizar' ? false : true);
    const valida_disabled_demandante = ref(props.view == 'actualizar' ? false : true);
    const nombres_demandado = ref(props.loadData.demandado);
    const nombres_demandante = ref(props.loadData.demandante);
    const tipo_documento_demandado = ref(props.loadData?.demandado?.tipoDocumento?.nombre_tipo_identificacion != 'NIT' ? true : false);
    const tipo_documento_demandante = ref(props.loadData?.demandante?.tipoDocumento?.nombre_tipo_identificacion != 'NIT' ? true : false);

    const entidadEmisoraSeleccionada = computed(() =>
      props.loadData.id_entidad_emisora
        ? props.loadData.id_entidad_emisora
        : (props.loadData.entidadEmisora ? props.loadData.entidadEmisora.id : ''),
    );

    const nitEntidadEmisora = computed(() => {
      const idSel = entidadEmisoraSeleccionada.value;
      if (!idSel) return '';
      const entidad = (props.collectionEntidadesEmisoras || []).find((e) => e.id == idSel);
      return entidad ? (entidad.nit || '') : '';
    });

    const formattedValue = computed(() => {
      if (valor.value !== '') {
        return separateNumberByCommaInput(valor.value);
      }else if (props.loadData.valor){
        return separateNumberByCommaInput(props.loadData.valor);
      }else {
        return separateNumberByCommaInput(props.loadData.valor_inicial);
      }
    });

    const updateValue = (newValue) => {
      valor.value = newValue;
      emit('updateValues', {valor: newValue});
    };

    const demandanteFieldsByDocument = async (value) => {
      
      emit('updateValues', { 'tipo_identificacion_demandante'  : props.customUpdateValueData('tipo_identificacion_demandante', value) })
      if (value == 6) {
        tipo_documento_demandante.value = false
      }else{
        tipo_documento_demandante.value = true
      }
    }

    const demandadoFieldsByDocument = async (value) => {
      emit('updateValues', { 'tipo_identificacion_demandado'  : props.customUpdateValueData('tipo_identificacion_demandado', value)})
      if (value == 6) {
        tipo_documento_demandado.value = false
      }else{
        tipo_documento_demandado.value = true
      }
    }

    const updatePersona = async (params) => {
      const nombres = {
        demandado: nombres_demandado,
        demandante: nombres_demandante
      };

      const clearInputs = (tipo,newDocument = null) => {
        tipo == 'demandado' ? valida_disabled_demandado.value = true : valida_disabled_demandante.value = true 

        emit('updateValues', { 
          [`identificacion_${tipo}`]  : newDocument ? newDocument : '',
          [`primer_nombre_${tipo}`]   : '',
          [`segundo_nombre_${tipo}`]  : '',
          [`primer_apellido_${tipo}`] : '',
          [`segundo_apellido_${tipo}`]: '',
        });

        nombres[tipo].value = {
          identificacion   : '',
          primer_nombre    : '',
          segundo_nombre   : '',
          primer_apellido  : '',
          segundo_apellido : '',
        }
      }

      if (params.documento) {
        await useAPIRest(process.env.VUE_APP_NEST_PERSONA_FINDBYDOC.replace(":type", params.tipoDocumento).replace(":id", params.documento),"GET", props.authToken, undefined, undefined , "application/json")
        .then((res) => {
          if (res.statusCode == 200) {

            params.tipo == 'demandado' ? valida_disabled_demandado.value = false : valida_disabled_demandante.value = false;
            
            emit("updateValues", {
              [`identificacion_${params.tipo}`]   : res.identificacion, 
              [`primer_nombre_${params.tipo}`]    : res.primer_nombre,
              [`segundo_nombre_${params.tipo}`]   : res.segundo_nombre,
              [`primer_apellido_${params.tipo}`]  : res.primer_apellido,
              [`segundo_apellido_${params.tipo}`] : res.segundo_apellido
            });
            
          } else if (res.statusCode == 400) {
            params.tipo == 'demandado' ? valida_disabled_demandado.value = true: valida_disabled_demandante.value = true;
            clearInputs(params.tipo, params.documento)
          }
        })
      }else{
        clearInputs(params.tipo)
      }
    }

    return{
      entidadEmisoraSeleccionada,
      nitEntidadEmisora,
      formattedValue,
      updateValue,
      demandanteFieldsByDocument,
      demandadoFieldsByDocument,
      updatePersona,
      nombres_demandado,
      nombres_demandante,
      valida_disabled_demandado,
      valida_disabled_demandante,
      tipo_documento_demandado,
      tipo_documento_demandante,
    };
  }
}
</script>